import React, { useState } from "react";
import ReactDOM from "react-dom";
import AuthService from "../../services/auth/auth.service";


const Login = () => {
  const [errorMessages, setErrorMessages] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (event) => {
    //Prevent page reload
    event.preventDefault();
    
    var { uname, upass, remember } = document.forms[0];


    AuthService.login(uname.value, upass.value, remember.checked).then(
      () => { 
        window.location.href = '/'
      }
    
    ).catch(
      function (error) {
        console.log(error)
        console.log(error.message);
        setErrorMessages({message:'Nieprawidłowy login lub hasło!'});
      }
    );  
    
 
   
  };

  const renderErrorMessage = () =>
    (
      <p style={{color:'#FF0000'}} className="login-box-msg">{errorMessages.message}</p>

    );

  const renderForm = (
    <div className="card-body">
           
            <form onSubmit={handleSubmit} method="post">
              <div className="input-group mb-3">
                <input type="email" className="form-control" name="uname" placeholder="Email" />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-envelope" />
                  </div>
                </div>
              </div>
              <div className="input-group mb-3">
                <input type="password" className="form-control" name="upass" placeholder="Password" />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-lock" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-8">
                  <div className="icheck-primary">
                    <input type="checkbox" id="remember" name="remember"/>
                    <label htmlFor="remember">
                      Zapamiętaj mnie
                    </label>
                  </div>
                </div>
                {/* /.col */}
                <div className="col-4">
                  <button type="submit" className="btn btn-primary btn-block">Zaloguj</button>
                </div>
                {/* /.col */}
              </div>
            </form>
            {/*<div className="social-auth-links text-center mt-2 mb-3">
              <a href="#" className="btn btn-block btn-primary">
                <i className="fab fa-facebook mr-2" /> Zaloguj z Facebook
              </a>
              <a href="#" className="btn btn-block btn-danger">
                <i className="fab fa-google-plus mr-2" /> Zaloguj z Google+
              </a>
            </div>
            
            <p className="mb-1">
              <a href="forgot-password.html">Zapomniałem hasła</a>
            </p>  
          */}
          </div>
    
  );
  
    return (
      <div className="login-box">
        <div className="card card-outline card-primary">
          <div className="card-header text-center">
            <a href="/login" className="h1"><b>CRM</b>ExpoProperty</a>
          </div>
          {errorMessages.message ? renderErrorMessage() : <p className="login-box-msg">Zaloguj się</p>}
          {isSubmitted ? <div>Poprawnie zalogowano użytkownika</div> : renderForm}
        </div>
      </div>

    )
  }
  
  export default Login;